import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, FieldArray, reduxForm } from "redux-form";
import AppWrapper from "../../Common/AppWrapper/index.jsx";
import { CopyNumberDeterminationIdentifier } from "./CopyNumberDeterminationIdentifier.jsx";
import { CopyNumberDeterminationSequence } from "./CopyNumberDeterminationSequence.jsx";
import * as assayActions from "../../../actions/assays.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import _ from "underscore";
import "../AssayCreate.scss";

export const CopyNumberDeterminationForm = ({ fields, custom }) => {
  const validatedAssayDetails = (custom && custom.validatedAssayDetails) || {};
  const formValues =
    custom &&
    custom.formObj &&
    custom.formObj.values &&
    custom.formObj.values.copyNumberDeterminationForm;
    
    const targetByValue = custom &&
    custom.formObj &&
    custom.formObj.values && custom.formObj.values.targetby;
  return (
    <div>
      {fields.map((copyNumberDeterminationForm, index) => {
        //const targetByValue = formValues && formValues[0].targetby;
        //const formobj = formValues && formValues[index];
        //const values = formValues && formValues[index];

        return (
          <Fragment key={index}>
            <div className="row">
              {targetByValue && targetByValue === "identifier" && (
                <div className="col">
                  <Field
                    name={`${copyNumberDeterminationForm}.copynumberdeterminationidentifier`}
                    component={CopyNumberDeterminationIdentifier}
                    index={index}
                    custom={custom}
                  />
                </div>
              )}

              {targetByValue && targetByValue === "sequence" && (
                <div className="col">
                  <Field
                    name={`${copyNumberDeterminationForm}.copynumberdeterminationsequence`}
                    component={CopyNumberDeterminationSequence}
                    index={index}
                    custom={custom}
                  />
                </div>
              )}
              {fields.length > 1 && (
                <div className="col-md-auto">
                  <a
                    alt="Remove"
                    title="Remove"
                    className="del-field"
                    href=""
                    onClick={(e) => (e.preventDefault(), fields.remove(index))}
                  >
                    <i className="fa fa-minus" aria-hidden="true"></i>
                  </a>
                </div>
              )}
            </div>
          </Fragment>
        );
      })}
      <div className="row">
        <div className="col">
          <div className="btn-add-target">
            <button
              className="outline rounded"
              onClick={(e) => (
                e.preventDefault(),
                fields.push({
                  
                  copynumberdeterminationidentifier: {
                    genome: "Home sapiens",
                    fluorophores: "FAM",
                    created_at: epochDate,
                    assayType: "Gene",
                  },
                  copynumberdeterminationsequence: {
                    assayTargetName: "",
                    genome: "Home sapiens",
                    fluorophores: "FAM",
                    created_at: epochDate,
                    assayType: "DnaSequence",
                  },
                })
              )}
            >
              <i className="fas fa-plus" />
              &nbsp;Add Target
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

CopyNumberDeterminationForm.propTypes = {
  formObj: PropTypes.object,
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  actions: PropTypes.object,
};
const epochDate = new Date().getTime();
